import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Text } from '../models';

export const textActions = createActionGroup({
    source: 'Text',
    events: {
        'Get Text': props<{ id: string }>(),
        'Get Text Success': props<{ payload: Text }>(),
        'Get Text Error': props<{ id: string; code: number }>(),
        'Set Loading': props<{ id: string }>(),
        Clear: emptyProps(),
    },
});
